// AUTO-GENERATED by scripts/gen-progress-colors — do not edit by hand.
// Literal Tailwind class strings for every color in the v4 palette so the
// scanner can detect them in the published dist (template-built names are
// invisible to Tailwind's JIT). Regenerate after changing the palette.
import type { Color } from "../../utils/types";

export const progressFill: Record<Color, string> = {
  slate: "bg-slate-500 dark:bg-slate-400",
  gray: "bg-gray-500 dark:bg-gray-400",
  zinc: "bg-zinc-500 dark:bg-zinc-400",
  neutral: "bg-neutral-500 dark:bg-neutral-400",
  stone: "bg-stone-500 dark:bg-stone-400",
  red: "bg-red-500 dark:bg-red-400",
  orange: "bg-orange-500 dark:bg-orange-400",
  amber: "bg-amber-500 dark:bg-amber-400",
  yellow: "bg-yellow-500 dark:bg-yellow-400",
  lime: "bg-lime-500 dark:bg-lime-400",
  green: "bg-green-500 dark:bg-green-400",
  emerald: "bg-emerald-500 dark:bg-emerald-400",
  teal: "bg-teal-500 dark:bg-teal-400",
  cyan: "bg-cyan-500 dark:bg-cyan-400",
  sky: "bg-sky-500 dark:bg-sky-400",
  blue: "bg-blue-500 dark:bg-blue-400",
  indigo: "bg-indigo-500 dark:bg-indigo-400",
  violet: "bg-violet-500 dark:bg-violet-400",
  purple: "bg-purple-500 dark:bg-purple-400",
  fuchsia: "bg-fuchsia-500 dark:bg-fuchsia-400",
  pink: "bg-pink-500 dark:bg-pink-400",
  rose: "bg-rose-500 dark:bg-rose-400",
};

export const progressStroke: Record<Color, string> = {
  slate: "stroke-slate-500 dark:stroke-slate-400",
  gray: "stroke-gray-500 dark:stroke-gray-400",
  zinc: "stroke-zinc-500 dark:stroke-zinc-400",
  neutral: "stroke-neutral-500 dark:stroke-neutral-400",
  stone: "stroke-stone-500 dark:stroke-stone-400",
  red: "stroke-red-500 dark:stroke-red-400",
  orange: "stroke-orange-500 dark:stroke-orange-400",
  amber: "stroke-amber-500 dark:stroke-amber-400",
  yellow: "stroke-yellow-500 dark:stroke-yellow-400",
  lime: "stroke-lime-500 dark:stroke-lime-400",
  green: "stroke-green-500 dark:stroke-green-400",
  emerald: "stroke-emerald-500 dark:stroke-emerald-400",
  teal: "stroke-teal-500 dark:stroke-teal-400",
  cyan: "stroke-cyan-500 dark:stroke-cyan-400",
  sky: "stroke-sky-500 dark:stroke-sky-400",
  blue: "stroke-blue-500 dark:stroke-blue-400",
  indigo: "stroke-indigo-500 dark:stroke-indigo-400",
  violet: "stroke-violet-500 dark:stroke-violet-400",
  purple: "stroke-purple-500 dark:stroke-purple-400",
  fuchsia: "stroke-fuchsia-500 dark:stroke-fuchsia-400",
  pink: "stroke-pink-500 dark:stroke-pink-400",
  rose: "stroke-rose-500 dark:stroke-rose-400",
};

export const progressText: Record<Color, string> = {
  slate: "text-slate-600 dark:text-slate-400",
  gray: "text-gray-600 dark:text-gray-400",
  zinc: "text-zinc-600 dark:text-zinc-400",
  neutral: "text-neutral-600 dark:text-neutral-400",
  stone: "text-stone-600 dark:text-stone-400",
  red: "text-red-600 dark:text-red-400",
  orange: "text-orange-600 dark:text-orange-400",
  amber: "text-amber-600 dark:text-amber-400",
  yellow: "text-yellow-600 dark:text-yellow-400",
  lime: "text-lime-600 dark:text-lime-400",
  green: "text-green-600 dark:text-green-400",
  emerald: "text-emerald-600 dark:text-emerald-400",
  teal: "text-teal-600 dark:text-teal-400",
  cyan: "text-cyan-600 dark:text-cyan-400",
  sky: "text-sky-600 dark:text-sky-400",
  blue: "text-blue-600 dark:text-blue-400",
  indigo: "text-indigo-600 dark:text-indigo-400",
  violet: "text-violet-600 dark:text-violet-400",
  purple: "text-purple-600 dark:text-purple-400",
  fuchsia: "text-fuchsia-600 dark:text-fuchsia-400",
  pink: "text-pink-600 dark:text-pink-400",
  rose: "text-rose-600 dark:text-rose-400",
};
